<template>
    <el-dialog
    :title="dialogTitle"
    :visible.sync="visible"
    width="30%"
    @close="close"
   >
     <el-row v-if="finished">
      <el-col :class="errorMsg ? 'mb-40' : 'mb-20'">商品总数：{{total}}款，成功{{success}}款，失败{{failure}}款</el-col>
      <el-col v-if="errorMsg && total === 1" class="fail-resean">
        <span>失败原因：</span>
        <el-link @click="jumpDetail">{{errorMsg}}</el-link>
      </el-col>
      <el-col v-if="promptMsg && total === 1">
        <span style="color: #2695FA;">提示：{{ promptMsg }}</span>
      </el-col>
      <div v-if="hasRetry" class="retry-tips el-link el-link--primary">
        <em class="el-icon-info"></em>
        <span class="tips-content">存在参与“自动重试”逻辑而铺货成功的商品，这部分商品的数据会被修改，请参照日志详情到平台修复数据。</span>
      </div>
      <!-- <div style="color: red;" class="mgt12 ftsz12" v-if="+failure && !errorMsg.includes('店铺未设置运费模版')">
        小提示：建议将要铺货商品加入分销商品，再导入至商品资料，编辑后铺货
      </div> -->
    </el-row> 
    <el-row v-else>
      <el-col class="mb-20">商品总数：{{total}}款</el-col>
      <el-col class="mb-20" v-if="goodsFissionProgressInfo">
        商品裂变任务进行中...(总数：{{goodsFissionProgressInfo.total || 0}}，成功：{{goodsFissionProgressInfo.success || 0}}，失败：{{goodsFissionProgressInfo.fail || 0}})
      </el-col>
      <el-col class="mb-20">商品铺货中...(成功：{{success}}，失败：{{failure}})</el-col>
      <el-col class="mb-20">
        <el-progress class="progress-bar" :stroke-width="24" :percentage="getPercentage"></el-progress>
      </el-col>
      <el-col v-if="['EDIT_ITEM', 'OFF_SALE_ITEM', 'BATCH_EDIT_ITEM'].includes(publishType)">收起之后可在“商品日志-更新店铺商品”中查看</el-col>
      <el-col v-else-if="publishType === 'GOODS_FISSION'">收起弹窗后，可在“任务中心“查看裂变任务详情，“商品日志-铺货日志”中查看铺货详情</el-col>
      <el-col v-else>收起之后可在“商品日志-铺货日志”中查看</el-col>
    </el-row> 
    <span slot="footer" class="dialog-footer">
      <template v-if="finished">
        <el-button v-show="!showList.includes(speedCurrentPage)" type="primary" @click="handleDeatil">查看日志</el-button>
      </template>
      <el-button v-else type="primary" @click="handleClose">收 起</el-button>
    </span>
    <!-- 铺货日志 -->
    <ProdLog ref="ProdLog" />
  </el-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapActions} from 'vuex'
import ProdLog from "@/components/prod/center/dialogs/ProdLog.vue";

export default {
  name: 'BulkShelvesResults',
  props: {
    publishSpeedResult: {
      type: Object,
      default: ()=> {
        return {}
      }
    },
    percentage: {
      type: Number,
      default: 0
    },
    pageId:{
      type: String,
      default: ''
    },
    isSearch:{ // 关闭弹窗后是否要刷新列表
      type:Boolean,
      default:false
    },
  },
  components: {
    ProdLog
  },
  data() {
    return {
      jumpFn: null
    }
  },
  computed: {
    ...mapGetters(['speedResultVisible', 'routerPrefix', 'speedCurrentPage','speedPublishType']),
    finished() {
      return this.publishSpeedResult.finished || false;
    },
    total() {
      return this.publishSpeedResult.result.total || 0;
    },
    success() {
      return this.publishSpeedResult.result.success || 0;
    },
    failure() {
      return this.publishSpeedResult.result.failure || 0;
    },
    goodsFissionProgressInfo(){
      return this.publishSpeedResult.result.goodsFissionProgressInfo || null;
    },
    hasRetry() {
      return this.publishSpeedResult.hasSucRetry || false;
    },
    errorMsg() {
      return this.publishSpeedResult.errorMsg || ''
    },
    promptMsg() {
      return this.publishSpeedResult.promptMsg || ''
    },
    errorId() {
      return this.publishSpeedResult.errorId || ''
    },
    publishType() {
      return this.speedPublishType(this.pageId) || 'PUBLISH_ITEM'
    },
    getPercentage(){
      return Number(this.percentage.toFixed(2))
    },
    visible: {
      get() {
        return this.speedResultVisible(this.pageId)
      },
      set(v) {
        this.setResultVisible(v)
      }
    },
    showList() {
      return [
        `${this.routerPrefix}log`,
        `${this.routerPrefix}updateLog`
      ]
    },
    dialogTitle() {
      let keywords = '铺货';
      if (this.publishType === 'OFF_SALE_ITEM') {
        keywords = '下架';
      }
      return this.finished ? `${keywords}完成` : `${keywords}中…`
    },
  
  },
  methods: {
     ...mapMutations(['setResultVisible','setIsForceStop', 'setActiveName']),
     ...mapActions(['clearPublishSpeedResult', 'clearPercentage']),
     jumpDetail() {
        this.visible = false;
       if(['EDIT_ITEM', 'OFF_SALE_ITEM', 'BATCH_EDIT_ITEM'].includes(this.publishType)) {
         this.setActiveName('updateToShopLog')
       } else {
         this.setActiveName('onShelvesLog')
       }
       this.$emit('ready-to-jump')
        // 由于直接跳转可能导致el-dialog的蒙层dom未销毁
        // 所以用方法包裹跳转 在蒙层关闭后进行跳转 确保蒙层dom销毁
        this.jumpFn = () => {
          this.$router.push({
            name: `${this.routerPrefix}prod_log`,
            query:{
              id: this.errorId
            }
          })
        }
      },
     handleDeatil() {
       this.visible = false;
       if(['EDIT_ITEM', 'OFF_SALE_ITEM', 'BATCH_EDIT_ITEM'].includes(this.publishType)) {
         this.setActiveName('updateToShopLog')
       } else {
         this.setActiveName('onShelvesLog')
       }
       this.$emit('ready-to-jump')
      // 由于直接跳转可能导致el-dialog的蒙层dom未销毁
      // 所以用方法包裹跳转 在蒙层关闭后进行跳转 确保蒙层dom销毁
       this.jumpFn = () => {
        if (this.$fromGyl) {
          this.$refs.ProdLog.method_open(); 
        } else {
          this.$router.push({name: `${this.routerPrefix}prod_log`});
        }
       }
     },
     handleClose() {
       this.visible = false;
       this.setIsForceStop(true);
       this.clearPublishSpeedResult();
       this.clearPercentage()
     },
     close() {
      // 由于直接跳转可能导致el-dialog的蒙层dom未销毁
      // 所以用方法包裹跳转 在蒙层关闭后进行跳转 确保蒙层dom销毁
       if (this.jumpFn) {
         this.jumpFn()
         this.jumpFn = null
       }
       this.handleClose();
       if(this.isSearch){
        this.$emit('search'); // 铺货完成后刷新列表
       }
     }
  }
}
</script>

<style lang="scss" scoped>
.mb-20{
  margin-bottom: 20px;
}
.mb-40{
  margin: 40px 0;
}
.retry-tips{
  margin-top: 20px;
  cursor: default;
  .el-icon-info{
    font-size: 20px;
  }
}
.progress-bar {
  ::v-deep .el-progress-bar{
    margin-right: -86px;
    padding-right: 86px;
  }
}
</style>
